// extracted by mini-css-extract-plugin
export var closeButton = "_j3-1";
export var closeX = "_j3-3";
export var container = "_j3-0";
export var image = "_j3-2";